/* Les Pépites d'Adeline — diaporama d'accueil (élément personnalisé, compatible éditeur de thème) */
if (!customElements.get('pa-slideshow')) {
  customElements.define(
    'pa-slideshow',
    class PaSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.pa-slides__track');
        this.slides = Array.from(this.querySelectorAll('.pa-slide'));
        this.dots = Array.from(this.querySelectorAll('.pa-slides__dots button'));
        if (this.slides.length < 2) return;

        this.duration = Number(this.dataset.duration) || 6000;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.current = 0;
        this.paused = false;

        if (this.dataset.random === 'true' && !window.Shopify?.designMode) {
          const order = this.slides.slice().sort(() => Math.random() - 0.5);
          const dotsBox = this.querySelector('.pa-slides__dots');
          order.forEach((slide) => this.track.appendChild(slide));
          this.slides = order;
          if (dotsBox) this.dots.forEach((d) => dotsBox.appendChild(d));
        }

        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
        this.querySelectorAll('.pa-slides__arrow').forEach((btn) =>
          btn.addEventListener('click', () => this.go(this.current + Number(btn.dataset.dir)))
        );

        this.addEventListener('mouseenter', () => this.setPaused(true));
        this.addEventListener('mouseleave', () => this.setPaused(false));
        this.addEventListener('focusin', () => this.setPaused(true));
        this.addEventListener('focusout', () => this.setPaused(false));

        let x0 = null;
        this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) this.go(this.current + (dx < 0 ? 1 : -1));
          x0 = null;
        });

        document.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.findIndex((s) => s.contains(e.target));
          if (i >= 0) { this.setPaused(true); this.go(i); }
        });
        document.addEventListener('shopify:block:deselect', () => this.setPaused(false));

        this.go(0);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      go(n) {
        this.current = (n + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const on = i === this.current;
          slide.classList.toggle('is-active', on);
          slide.setAttribute('aria-hidden', String(!on));
          slide.querySelectorAll('a, button').forEach((el) => {
            if (on) el.removeAttribute('tabindex');
            else el.setAttribute('tabindex', '-1');
          });
        });
        this.dots.forEach((d) => d.removeAttribute('aria-current'));
        void this.offsetWidth;
        if (this.dots[this.current]) this.dots[this.current].setAttribute('aria-current', 'true');
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (this.reduce || this.paused) return;
        this.timer = setTimeout(() => this.go(this.current + 1), this.duration);
      }

      setPaused(p) {
        this.paused = p;
        this.classList.toggle('is-paused', p);
        this.schedule();
      }
    }
  );
}
